import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.video', [
  'whyline.resources.resource',
]);

const VideoFactory = (Resource, $http, $state, API_URL) => {
  /*@ngInject*/
  //API REST Resource Name
  const _type = 'video?placeId';

  const _schema = {
    name: {
      type: String,
    },
    src: {
      type: String,
    }
  };

  const Video = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  Video.prototype = new Resource(_type, _schema, Video);

  Resource.Extend(_type, Video);

  //one minute
  const validityTime = 5 * 60 * 1000;
  Video.InitCache(validityTime);

  Video.Save = async video => {
    const configuration = {
      data: video,
      method: video._id ? 'PUT' : 'POST',
      url: `${API_URL}place/video?placeId`,
    };

    const { data } = await $http(configuration);
    return data;
  };

  Video.Remove = async videoId => {
    const url = `${API_URL}place/video/${videoId}?placeId`;
    const { data } = await $http.delete(url);
    return data;
  };

  return Video;
};

module.exports = module.factory('Video', VideoFactory);
